import { render, staticRenderFns } from "./rankPurchaseCount.vue?vue&type=template&id=4222a74e"
import script from "./rankPurchaseCount.vue?vue&type=script&lang=js"
export * from "./rankPurchaseCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports